import {
	getController,
	apiService as Service,
	type HpRequestOptional,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'person_updaterequests'

export const personUpdateRequestService = {
	...getController(url),
	storePersonData: (data: HpRequestPostPut<Api.PersonUpdateRequestPostInput>) =>
		Service.post({ url, ...data }),
	getRequest: (id: number) => Service.get({ url: `${url}/${id}/process` }),
	approveRequest: (id: number, data?: HpRequestOptional) =>
		Service.put({ url: `${url}/${id}/approve`, ...data }),
	rejectRequest: (
		id: number,
		data: HpRequestPostPut<{ denied_cause: string }>
	) => Service.put({ url: `${url}/${id}/reject`, ...data }),
	deleteRequest: (id: number) => Service.delete({ url: `${url}/${id}` }),
	notifyPersonData: (data: HpRequestPostPut<{ id: number; type: string }>) =>
		Service.post({
			url: `/notifications/personupdaterequest`,
			data,
		}),
}

export default personUpdateRequestService
